<auto-main-navigation [accountId]="accountId"></auto-main-navigation>
<p-panel>
  <p-header class="settings-header-wrapper">
    <h1 class="settings-header">MPOP Settings</h1>
  </p-header>
  <div class="main-content-wrapper p-grid">
    <div class="p-col-3">
      <p-panelMenu [model]="settingsSideNav"></p-panelMenu>
    </div>
    <p-panel class="p-col ad-types-wrapper">
      <ng-template pTemplate="header">
        <div class="panel-header-content">
          <h2>Advanced Settings</h2>
          <div class="button-spinner-container">
            <button pButton class="p-button-success save-button" label="Save"
              [disabled]="getSaveButtonDisabled() || saveSettingsLoading"
            (click)="onSaveButtonClicked()"></button>
            @if (saveSettingsLoading) {
              <p-progressSpinner
                [style]="{'height': '3rem'}"
                strokeWidth="8">
              </p-progressSpinner>
            }
          </div>
        </div>
      </ng-template>
      <p-tabs value="general">
        <p-tablist>
          <p-tab value="general">General <i class="pi pi-fw pi-cog"></i></p-tab>
          <p-tab value="offerSets">Offer Sets <i class="pi pi-fw pi-cog"></i></p-tab>
          @if (showDisclosuresTab) {
            <p-tab value="disclosures">Disclosures <i class="pi pi-fw pi-file-edit"></i></p-tab>
          }
          <p-tab value="pageManagement">Page Management <i class="pi pi-fw pi-file"></i></p-tab>
          <p-tab value="leadManagement">Lead Management <i class="pi pi-fw pi-users"></i></p-tab>
          <p-tab value="serviceCategories">Service Categories <i class="pi pi-fw pi-list"></i></p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="general">
            @if (advancedSettings) {
              <auto-advanced-general-settings
                [data]="advancedSettings"
                [preCacheBusyInput]="preCacheBusy"
                (dataEmitter)="onGeneralFormGroupInitialized($event)"
                (preCacheRequested)="onPreCacheRequested()">
              </auto-advanced-general-settings>
            }
          </p-tabpanel>
          <p-tabpanel value="offerSets">
            @if (advancedSettings) {
              <auto-advanced-offer-set-configuration
                [data]="advancedSettings"
                [showDisclosuresTab]="showDisclosuresTab"
                (dataEmitter)="onAdConfigFormGroupInitialized($event)">
              </auto-advanced-offer-set-configuration>
            }
          </p-tabpanel>
          @if (showDisclosuresTab) {
            <p-tabpanel value="disclosures">
              @if (advancedSettings) {
                <auto-advanced-disclosures
                  [data]="advancedSettings"
                  (dataEmitter)="onDisclosuresFormGroupInitialized($event)">
                </auto-advanced-disclosures>
              }
            </p-tabpanel>
          }
          <p-tabpanel value="pageManagement">
            @if (advancedSettings) {
              <auto-advanced-page-configuration
                [data]="advancedSettings"
                (dataEmitter)="onPageConfigFormGroupInitialized($event)">
              </auto-advanced-page-configuration>
            }
          </p-tabpanel>
          <p-tabpanel value="leadManagement">
            @if (advancedSettings) {
              <auto-advanced-lead-management
                [data]="advancedSettings"
                (dataEmitter)="onLeadManagementFormGroupInitialized($event)">
              </auto-advanced-lead-management>
            }
          </p-tabpanel>
          <p-tabpanel value="serviceCategories">
            @if (advancedSettings) {
              <auto-advanced-service-categories
                [data]="advancedSettings"
                (dataEmitter)="onServiceCategoriesFormGroupInitialized($event)">
              </auto-advanced-service-categories>
            }
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </p-panel>
  </div>
</p-panel>
<p-dialog
  header="Update Existing Offer Sets"
  [(visible)]="showDisclosureConfirmDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="false">
  <p>Saving these changes will update disclosures for all existing offer sets within this account. Are you sure you want to continue?</p>
  <ng-template pTemplate="footer">
    <div class="disclosure-confirm-dialog-footer">
      <button
        pButton
        type="button"
        label="Save"
        class="p-button-success"
        (click)="onDisclosureSaveConfirmed()">
      </button>
      <button
        pButton
        type="button"
        label="Skip updates"
        class="p-button-secondary p-button-sm"
        (click)="onDisclosureSkipUpdates()">
      </button>
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-danger"
        (click)="onDisclosureConfirmCancelled()">
      </button>
    </div>
  </ng-template>
</p-dialog>
<auto-footer></auto-footer>
